import React from 'react';
import { component_tool } from '@/tool';
const { WizComponent } = component_tool;
import PropTypes from 'prop-types';
import '@/styles/containers/interview/resumeExport.less';
import { PositionRadar } from '@/components';

export default class ResumeExportView extends WizComponent {
  componentName = 'ResumeExportView';

  constructor(props) {
    super(props);
    this.state = {};
  }

  _title = (title = '人员简历信息') => {
    return (
      <div className="resume-title">
        {title}
        <div>
          <img
            className="resume-title-img buick-img"
            src={constants.files.sys_icon_resume_buick}
          />
          <img
            className="resume-title-img"
            src={constants.files.sys_icon_resume_logo}
          />
        </div>
      </div>
    );
  };

  /**
   * 基础信息
   */
  _base = ({
    ultraman,
    name,
    birthday,
    gender,
    constellation,
    blood,
    idCard,
    phone,
    height,
    weight
  }) => {
    return (
      <div className="resume-export-base">
        <div className="export-less-title">基础信息</div>
        <div className="export-basic">
          <img className="export-basic-img" src={getOssFilePath(ultraman)} />
          <div className="export-basic-view">
            <div className="pdf-name">{name}</div>
            <div className="pdf-one">{`${birthday} | ${gender} | ${constellation} | ${blood}`}</div>
            <div className="pdf-two">
              <span>身份证号：{idCard}</span>
              <span>手机号：{phone}</span>
            </div>
            <div className="pdf-three">
              <span>身高：{height || 0}cm</span>
              <span>体重：{weight || 0}kg</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  /**
   * 教育&行业经历
   */
  _source = ({
    education,
    graduation,
    specializedSubject,
    language,
    experience,
    achievement,
    cutOut,
    contacts
  }) => {
    let subStr = str => {
      return str ? (str.length < 13 ? str : str.substring(0, 13) + '...') : '';
    };
    return (
      <div className="resume-export-base">
        <div className="export-less-title">教育&行业经历</div>
        <div className="export-source">
          <div className="pdf-source">
            <span>最高学历：{subStr(education)}</span>
            <span>毕业学院：{subStr(graduation)}</span>
          </div>
          <div className="pdf-source font-space">
            <span>专业：{subStr(specializedSubject)}</span>
            <span>语言语种：{subStr(language)}</span>
          </div>
          <div className="pdf-source font-space">
            <span>过往行业经历：{subStr(experience)}</span>
            <span>最高业绩：{subStr(achievement)}</span>
          </div>
          <div className="pdf-source font-space">
            <span>背调联系人：{subStr(cutOut)}</span>
            <span>背调人联系电话：{subStr(contacts)}</span>
          </div>
        </div>
      </div>
    );
  };

  /**
   * 技能特长
   */
  _skill = ({ office, drive, hobby }) => {
    return (
      <div className="resume-export-base">
        <div className="export-less-title">技能特长</div>
        <div className="export-row">
          <div>办公软件：</div>
          <div>{office}</div>
        </div>
        <div className="export-row font-space">
          <div>驾驶能力：</div>
          <div>{drive}</div>
        </div>
        <div className="export-row font-space">
          <div>爱好/兴趣：</div>
          <div>{hobby}</div>
        </div>
      </div>
    );
  };

  /**
   * 工作经验
   */
  _exp = ({
    live = [],
    currentPosition,
    willingness,
    authLevel,
    workExp,
    nine,
    five,
    two,
    seven
  }) => {
    return (
      <div className="resume-export-base">
        <div className="export-less-title">工作经验</div>
        <div className="export-exp">
          <div className="exp-title">生活照</div>
          <div className="exp-img-group">
            {live.map(e => {
              //html2Canvas生成图片时object-fit会失效，故用了背景图的方式
              return (
                <div
                  style={{
                    backgroundImage: `url(${getOssFilePath(e)})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    objectPosition: 100,
                    objectFit: 'cover',
                    height: 125 * 1.3,
                    width: 100 * 1.3,
                    marginRight: 20
                  }}
                />
              );
              //<img className="exp-img" src={getOssFilePath(e)} />;
            })}
          </div>
        </div>
        <div className="export-exp font-space">
          <div className="exp-title">现任岗位</div>
          <div>{currentPosition}</div>
        </div>
        <div className="export-exp font-space">
          <div className="exp-title">NEV岗位意愿度</div>
          <div>{willingness}</div>
        </div>
        <div className="export-exp font-space">
          <div className="exp-title">星级认证</div>
          <div>{authLevel}</div>
        </div>
        <div className="export-exp font-space">
          <div className="exp-title">工作经历</div>
          <div>{workExp}</div>
        </div>
        <div className="export-exp font-space">
          <div className="exp-title">
            你最有成就感的经历是什么？（工作或过往经历皆可）
          </div>
          <div>{nine}</div>
        </div>
        <div className="export-exp font-space">
          <div className="exp-title">
            你经历过的最失败的挫折是什么？是如何应对的？（工作或过往经历皆可）
          </div>
          <div>{five}</div>
        </div>
        <div className="export-exp font-space">
          <div className="exp-title">请描述你对新能源汽车行业的看法？</div>
          <div>{two}</div>
        </div>
        <div className="export-exp font-space">
          <div className="exp-title">未来3年你最想达成的目标是什么？</div>
          <div>{seven}</div>
        </div>
      </div>
    );
  };

  /**
   * 性格测评模型
   */
  _model = ({
    data = {},
    user = { a: '性格测评模型' },
    score = {
      min: 0,
      max: 20,
      tickInterval: 4 //用于指定坐标轴各个标度点的间距，是原始数据之间的间距差值
    }
  }) => {
    return (
      <div className="resume-export-base">
        <div className="export-less-title">性格测评模型</div>
        <PositionRadar
          key={data.length || 'radar'}
          height={400}
          width={650}
          stroke={'#dbdbdb'}
          other={{
            style: {
              border: '0px solid #E7E7E7',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              marginLeft: 10
            }
          }}
          radarProps={{
            data,
            colors: ['#FF0000'],
            dataFormat: {
              type: 'fold',
              fields: ['a'],
              key: 'user',
              value: 'score'
            },
            cols: {
              score,
              user: {
                formatter: val => user[val]
              }
            }
          }}
        />
      </div>
    );
  };

  /**
   * 测评结果
   */
  _result = ({ extResult, extValue }) => {
    return (
      <div className="resume-export-base">
        <div className="export-less-title">测试结果</div>
        <div>{extResult}</div>
        <div
          className="font-space"
          dangerouslySetInnerHTML={{
            __html: `${extValue}`
          }}
        />
      </div>
    );
  };

  /**
   * 性格趋向
   */
  _trend = ({ trend, trendInfo }) => {
    return (
      <div className="resume-export-base">
        <div className="export-less-title">性格趋向：{trend}</div>
        <div
          dangerouslySetInnerHTML={{
            __html: `${trendInfo}`
          }}
        />
      </div>
    );
  };

  /**
   * 工作关系
   */
  _relation = ({ result }) => {
    return (
      <div className="resume-export-base">
        <div className="export-less-title">工作关系</div>
        <div
          dangerouslySetInnerHTML={{
            __html: `${result}`
          }}
        />
      </div>
    );
  };

  render() {
    let { data = {}, leida = {} } = this.props;
    console.log('state:', data, leida);
    return data?.name ? (
      <div className="export-main">
        {this._title('人员简历信息')}
        {this._base(data)}
        {this._source(data)}
        {this._skill(data)}
        {this._exp(data)}
        {this._title('性格测评解读')}
        {this._model(leida)}
        {this._result(data)}
        {this._trend(data)}
        {this._relation(data)}
      </div>
    ) : null;
  }
}

ResumeExportView.propTypes = {
  data: {},
  leida: {}
};

ResumeExportView.defaultProps = {
  /**
   * 面试基本信息数据
   */
  data: PropTypes.object,
  /**
   * 蜘蛛图数据
   */
  leida: PropTypes.object
};
